import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';

import type { Query } from '../../generated';

/**
 * Invalidates the cached empty state of a query. This is only necessary if
 * we're treating `null` as a cached value in the query under `typePolicies`.
 *
 * @see {@link '../../client/cache'}

 * @param queryName query to invalidate
 *
 * @returns invalidation function
 */
export const useInvalidateEmptyQuery = (queryName: keyof Query) => {
  const client = useApolloClient();

  return useCallback(() => {
    client.cache.modify({
      broadcast: false,
      // @ts-expect-error
      fields: {
        [queryName]: (cached, details) =>
          // eslint-disable-next-line @typescript-eslint/no-unsafe-return
          cached === null ? details.DELETE : cached,
      },
    });
  }, [client.cache, queryName]);
};
